import { render } from "./detail-user.vue?vue&type=template&id=adecad60&scoped=true"
import script from "./detail-user.vue?vue&type=script&lang=js"
export * from "./detail-user.vue?vue&type=script&lang=js"

import "./detail-user.vue?vue&type=style&index=0&id=adecad60&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-adecad60"]])

export default __exports__